export const LocaleMixin = {
  methods: {
    getLocale: function() {
      let htmlBody = document.querySelector("html");
      let bodyLang = htmlBody.getAttribute("lang");

      if (bodyLang === "fr-FR" || bodyLang === "fr") {
        return "fr";
      } else if (bodyLang === "en-EN" || bodyLang === "en") {
        return "en";
      } else {
        return "fr";
      }
    }
  }
};
